// FEST Danışmanlık (Webpostman) REST API sağlayıcısı.
// Döküman: FEST Kargo Api Entegrasyon.pdf + örnek kodlar.
// İş mantığı Webpostman fabrikasında ortaktır (bkz. webpostman.ts); FEST yalnız taban URL ile ayrışır.
import { createWebpostmanProvider } from './webpostman'

// FEST doğrudan IP:port üzerinden hizmet verir (webpostman.deposerileti.com değil).
const FEST_BASE = 'http://185.241.103.28:90/restapi/client'

export const festProvider = createWebpostmanProvider('fest', FEST_BASE)

// Geriye dönük uyumluluk: yardımcılar önceden bu modülden dışa aktarılıyordu.
export { toAmountString, buildConsignmentForm } from './webpostman'
